import React, { FC, useCallback } from 'react';

import styled from 'styled-components';

import { UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import UICheckbox, { EUICheckboxVariant } from '@aquariuxfintech/aqx-trader-react-ui/checkbox';
import UIFormItem from '@aquariuxfintech/aqx-trader-react-ui/form';
import UIText, { EUITextVariant } from '@aquariuxfintech/aqx-trader-react-ui/text';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { ISignUpBasicValues } from '@aqx-core/common/hooks/form/use-sign-up-crm-form';

import AuthAcknowledgementText from '../../../shared/acknowledgement-text';

interface ISignUpCrmAcknowledgementFieldProps {
  tncAcknowledged: boolean;
  error?: string;
  setValue: UseFormSetValue<ISignUpBasicValues>;
  trigger: UseFormTrigger<ISignUpBasicValues>;
}

const SignUpCrmAcknowledgementField: FC<ISignUpCrmAcknowledgementFieldProps> = ({
  tncAcknowledged,
  error,
  trigger,
  setValue
}) => {
  const { t } = useTranslation();
  const onCheck = useCallback(() => {
    setValue('tncAcknowledged', !tncAcknowledged);
    trigger('tncAcknowledged');
  }, [setValue, tncAcknowledged, trigger]);

  return (
    <UIFormItem>
      <StyledCheckboxContainer>
        <UICheckbox
          dataTestId={
            tncAcknowledged ? EDataTestId.SIGN_UP_ACKNOWLEDGE_CHECKED : EDataTestId.SIGN_UP_ACKNOWLEDGE_UNCHECKED
          }
          checked={tncAcknowledged}
          onClick={onCheck}
          variant={EUICheckboxVariant.CHECKBOX_ONLY}
          error={!!error}
        />
        <AuthAcknowledgementText prefixText={t('I have read and agreed with the')} />
      </StyledCheckboxContainer>
      {!!error && <UIText variant={EUITextVariant.ERROR} error={error} />}
    </UIFormItem>
  );
};

export default SignUpCrmAcknowledgementField;

const StyledCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
